import React from 'react';

const Abc = () => (
    <div className='container'>
        <div className='jumbotron mt-5'>
            <h1 className='display-4'>you are logged in</h1>
            <p className='lead'>Great to see you here</p>
            <hr className='my-4' />
            <p>Thankew So much babe!</p>
        </div>
    </div>
);

export default Abc;
